import { useMemo } from "react";
import { getLocalisation } from "../utils/getLocalisation";


export const useLocalisation = () => {
  const localisation = useMemo(() => getLocalisation(), []);
  return { localisation };
};